import { Component, Injector, OnInit } from '@angular/core';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { ComponentContextService, DataFormBase, EventData, FormSchemaBase, SameValueValidator, TextControlSchema, UserService, UserV5Service } from 'tnx-shared';
import { AppUserService } from './services/app-user.service';

@Component({
    selector: 'reset-password-front-end',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss'],
    providers: [ComponentContextService]
})
export class ResetPasswordFrontEndComponent extends DataFormBase implements OnInit {

    constructor(
        protected _injector: Injector,
        protected _userV5Service: UserV5Service,
        public _userService: UserService,
        private _appUserService: AppUserService,
        private _recaptchaV3Service: ReCaptchaV3Service
    ) {
        super(_injector);
    }

    ngOnInit() {
        super.ngOnInit();

        this.setting.baseService = this._userV5Service;

        this.setting.schema = <FormSchemaBase[]>[
            new TextControlSchema({
                field: 'oldPassword',
                label: 'Mật khẩu cũ',
                dataFormat: 'password',
                mdWidth: 12,
                required: true
            }),
            new TextControlSchema({
                field: 'password',
                dataFormat: 'password',
                label: 'Mật khẩu (Mật khẩu từ 8 ký tự bao gồm chữ hoa, chữ thường, số và ký tự đặc biệt)',
                mdWidth: 12,
                required: true
            }),
            new TextControlSchema({
                field: 'confirmPassword',
                label: 'Gõ lại Mật khẩu',
                dataFormat: 'password',
                validators: [new SameValueValidator(['passwordHash'], 'Mật khẩu phải giống nhau')],
                mdWidth: 12,
                required: true
            })
        ];
    }


    save = async () => {
        const validated = await this.validateForm();
        if (validated) {

            this._recaptchaV3Service.execute('reCaptchaValue').subscribe((token) => {

                const formData = new FormData();
                formData.append('oldPassword', this.model.data.oldPassword);
                formData.append('password', this.model.data.password);
                formData.append('confirmPassword', this.model.data.confirmPassword);
                formData.append('reCaptchaValue', token);

                this._appUserService.changePassword(formData)
                    .then((response: any) => {
                        this.model.submitting = false;
                        if (response.success) {
                            this._notifierService.showSuccess('Đổi mật khẩu thành công');
                            this.onSaved.emit();
                        } else {
                            if (response.error?.error?.errors?.confirmPassword && response.error?.error?.errors?.confirmPassword.length
                                && response.error?.error?.errors?.confirmPassword[0] == "'ConfirmPassword' and 'Password' do not match.") {
                                this._notifierService.showWarning('Mật khẩu không chính xác, xin vui lòng thử lại');
                                return;
                            }
                            if (response.message) {
                                this._notifierService.showWarning(response.message);
                            } else {
                                this._notifierService.showWarning('Đổi mật khẩu không thành công');
                            }
                        }
                    }, error => {
                        if (!error.error.success && error.error.errorCheckExist) {
                            this.model.submitting = false;
                            return;
                        }
                        this.model.submitting = false;
                    });
            })

        } else {
            this.model.submitting = false;
        }
    }


    async onFormInitialized(constrols: EventData) {
        // tiền xử lý dữ liệu (ví dụ tổng hợp datasource), trước khi gọi api get detail
        if (this.model.data.id) {

        } else {
        }
    }

    async modifyDetailData(data) {
        data.passwordHash = '';
        // xử lý dữ liệu lấy từ get detail về
    }

    async onAfterGetDetail() {
        // xử lý dữ liệu sau khi đã lấy từ api (sau cả event modifyDetailData) về và trước khi hiển thị ra view
    }

    onBeforeSave() {
        // trước khi lưu
    }

}
